import moment from 'moment'
import { useEffect, useMemo, useState } from 'react'
import { CSVLink } from 'react-csv'
import { getPublicMessagesSearch } from '../../../../utils/APIs/publicMessages'
import { PRODUCT_CODE } from '../../../../utils/ENV'
import { toastError } from '../../../../utils/toast'
import Moaltip from '../../../Utilities/Tooltip'
import DateRangePicker from '../DateRangePicker'
import styles from '../Stats.module.css'

const ExportPublicChat = () => {
  const [downloadData, setDownloadData] = useState([])
  const [fileName, setFileName] = useState('my-file.csv')

  const [scaleType, setScaleType] = useState('timeseries')

  const [startDate, setStartDate] = useState(
    moment().subtract(1, 'days').toDate()
  )
  const [endDate, setEndDate] = useState(moment().toDate())

  useEffect(() => {
    setDownloadData([])
  }, [startDate, endDate])

  const columns = useMemo(
    () => [
      {
        Header: 'Post Date',
        accessor: 'postdate'
      },
      {
        Header: 'Message ID',
        accessor: '_id'
      },
      {
        Header: 'Message',
        accessor: 'message'
      },
      {
        Header: 'Hidden',
        accessor: 'hidden'
      },
      {
        Header: 'Reply To Message ID',
        accessor: 'replyTo._id'
      },
      {
        Header: 'User Service ID',
        accessor: 'user.userService._id'
      },
      {
        Header: 'Customer Number',
        accessor: 'user.userService.customerNumber'
      },
      {
        Header: 'Name',
        accessor: 'user.userService.profile.name'
      },
      {
        Header: 'Role',
        accessor: 'user.role.role'
      }
    ],
    []
  )

  const loadData = async () => {
    const response = await getPublicMessagesSearch({
      search: {
        startDate: moment(startDate).toISOString(),
        endDate: moment(endDate).toISOString(),
        limit: 0
      }
    })

    if (response && response.status === 200) {
      if (response.data.length === 0) {
        toastError('No Data in this Date Range')
        return
      }

      const start = moment(startDate).toISOString().split('T')[0]
      const end = moment(endDate).toISOString().split('T')[0]
      setFileName(`${PRODUCT_CODE}-public-messages-${start}-${end}.csv`)
      const toDownload = []

      const getNestedValue = (obj, path) => {
        return path.split('.').reduce((acc, part) => acc && acc[part], obj)
      }

      response.data.forEach((data) => {
        const dataRow = {}
        for (let colIndex = 0; colIndex < columns.length; colIndex++) {
          const dataPoint = columns[colIndex].accessor
          if (dataPoint) {
            dataRow[columns[colIndex].Header] = getNestedValue(data, dataPoint)
          }
        }
        toDownload.push(dataRow)
      })
      setDownloadData(toDownload)
    }
  }

  if (downloadData === null) {
    return (
      <div className={styles.wrapper}>
        <div className="flex items-center justify-center my-auto">
          <p className="animate-pulse">Loading...</p>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.wrapper}>
      <header className="flex items-center gap-2">
        <h2>Export Public Chat</h2>
        <Moaltip>
          This downloadable table displays detailed public message data
          including: Post Date, Message ID, Message, Hidden, Reply To Message
          ID, User Service ID, Customer Number, Name, and Role.
        </Moaltip>
      </header>

      <DateRangePicker
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        scaleType={scaleType}
        setScaleType={setScaleType}
      />
      {downloadData.length <= 0 && (
        <button className="button-confirm mx-2 mb-2 w-fit" onClick={loadData}>
          Load Data
        </button>
      )}
      {downloadData.length > 0 && (
        <CSVLink
          className="button-confirm mx-2 mb-2 w-fit"
          data={downloadData}
          filename={fileName}
        >
          Download
        </CSVLink>
      )}
    </div>
  )
}

export default ExportPublicChat
